<template>
    <div class="marketing-leads-award-form">
        <form-item
            label="手机号"
            validateKey="formData.mobile"
            class="mobile-box"
            :style="[textColor, placeholderColor]"
        >
            <CountryCode
                v-model="formData.country_code"
                @input="handleCountryCodeChange"
            />
            <input
                v-model="formData.mobile"
                ref="mobileIpt"
                type="number"
                pattern="[0-9]*"
                placeholder="请输入手机号"
                class="mobile-input"
                @focus="handleInputFocus('mobileIpt')"
                @blur="handleInputBlur()"
            />
            <span
                v-show="!!formData.mobile"
                class="editable-clear-x"
                @click="handleClearMobile"
            >
                <svg
                    t="1599754257072"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2046"
                    width="100%"
                >
                    <path
                        d="M512 0C229.187368 0 0 229.187368 0 512 0 794.812632 229.187368 1024 512 1024 794.812632 1024 1024 794.812632 1024 512 1024 229.187368 794.812632 0 512 0ZM512 970.105263C259.368421 970.105263 53.894737 764.631579 53.894737 512 53.894737 259.368421 259.368421 53.894737 512 53.894737 764.631579 53.894737 970.105263 259.368421 970.105263 512 970.105263 764.631579 764.631579 970.105263 512 970.105263ZM550.130526 512 719.629474 342.366316C730.273684 331.856842 730.273684 314.88 719.629474 304.370526 709.12 293.726316 692.143158 293.726316 681.633684 304.370526L512 473.869474 342.366316 304.370526C331.856842 293.726316 314.88 293.726316 304.370526 304.370526 293.726316 314.88 293.726316 331.856842 304.370526 342.366316L473.869474 512 304.370526 681.633684C293.726316 692.143158 293.726316 709.12 304.370526 719.629474 309.625263 724.884211 316.496842 727.578947 323.368421 727.578947 330.24 727.578947 337.111579 724.884211 342.366316 719.629474L512 550.130526 681.633684 719.629474C686.888421 724.884211 693.76 727.578947 700.631579 727.578947 707.503158 727.578947 714.374737 724.884211 719.629474 719.629474 730.273684 709.12 730.273684 692.143158 719.629474 681.633684L550.130526 512Z"
                        p-id="2047"
                    ></path>
                </svg>
            </span>
        </form-item>

        <form-item
            label="验证码"
            validateKey="formData.verification_code"
            class="verification_code-box"
            :style="[textColor, placeholderColor]"
        >
            <input
                v-model="formData.verification_code"
                ref="vCodeIpt"
                type="tel"
                pattern="[0-9]*"
                maxLength="6"
                placeholder="请输入验证码"
                class="verification_code-input"
                @focus="handleInputFocus('vCodeIpt')"
                @blur="handleInputBlur()"
            />
            <div
                class="verification_code-button"
                :class="{ disabled: isVerificationDis }"
                @click="handleClickVerification"
            >
                {{ butText }}
            </div>
        </form-item>

        <form-item
            v-if="fields.includes('fellowMobile')"
            label="专属顾问"
            validateKey="formData.fellow_mobile"
            class="mobile-box"
            :style="[textColor, placeholderColor]"
        >
             <input
                v-model="formData.fellow_mobile"
                ref="fellowMobileIpt"
                type="number"
                pattern="[0-9]*"
                placeholder="请输入对方手机号（选填）"
                class="mobile-input"
                @focus="handleInputFocus('fellowMobileIpt')"
                @blur="handleInputBlur()"
                @input="handleFellowMobileInput"
            />
            <span
                v-show="!!formData.fellow_mobile"
                class="editable-clear-x"
                @click="handleClearFellowMobile"
            >
                <svg
                    t="1599754257072"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2046"
                    width="100%"
                >
                    <path
                        d="M512 0C229.187368 0 0 229.187368 0 512 0 794.812632 229.187368 1024 512 1024 794.812632 1024 1024 794.812632 1024 512 1024 229.187368 794.812632 0 512 0ZM512 970.105263C259.368421 970.105263 53.894737 764.631579 53.894737 512 53.894737 259.368421 259.368421 53.894737 512 53.894737 764.631579 53.894737 970.105263 259.368421 970.105263 512 970.105263 764.631579 764.631579 970.105263 512 970.105263ZM550.130526 512 719.629474 342.366316C730.273684 331.856842 730.273684 314.88 719.629474 304.370526 709.12 293.726316 692.143158 293.726316 681.633684 304.370526L512 473.869474 342.366316 304.370526C331.856842 293.726316 314.88 293.726316 304.370526 304.370526 293.726316 314.88 293.726316 331.856842 304.370526 342.366316L473.869474 512 304.370526 681.633684C293.726316 692.143158 293.726316 709.12 304.370526 719.629474 309.625263 724.884211 316.496842 727.578947 323.368421 727.578947 330.24 727.578947 337.111579 724.884211 342.366316 719.629474L512 550.130526 681.633684 719.629474C686.888421 724.884211 693.76 727.578947 700.631579 727.578947 707.503158 727.578947 714.374737 724.884211 719.629474 719.629474 730.273684 709.12 730.273684 692.143158 719.629474 681.633684L550.130526 512Z"
                        p-id="2047"
                    ></path>
                </svg>
            </span>
        </form-item>

        <form-item validateKey="isAgree" :style="textColor" class="privacy-box">
            <Privacy
                linkLeftTxt="我已阅读并同意"
                :isAgree.sync="isAgree"
                :linkConfig="privacyList"
                :showMulti="true"
                @update:isAgree="handleAgreeChange"
            />
        </form-item>

        <AlertH5 ref="alerth5" />
    </div>
</template>

<script>
  import verificationMixin from '@/mixin/verification-marketing';
  import formMixin from '@/mixin/form';
  import CountryCode from '@/marketing_components/form/picker/country-code/index'; // @/components/form/picker/country-code/index
  import Privacy from '@/marketing_components/form/privacy/index.vue'; // @/components/form/privacy/index.vue
  import AlertH5 from '@/marketing_components/alert-h5'; // @/components/alert-h5
  import validator from '@/util/validator.js';
  import { isInNioCNApp } from '@/util/platform/universal';

  const fellow_country_code = '86';

  export default {
      name: 'marketing-leads-award-form',
      components: { CountryCode, Privacy, AlertH5 },
      mixins: [
          formMixin('formRules', 'validateKey'),
          verificationMixin('formData.mobile', 'formData.country_code')
      ],
      model: {
          prop: 'form',
          event: 'update'
      },
      props: {
          form: {
              type: Object,
              default: () => ({
                  country_code: '86', // 区号
                  mobile: '', // 手机号
                  verification_code: '', // 验证码
                  fellow_mobile: '' //fellow 手机号，选填
              })
          },
          campaignCode: {
              type: String,
              default: ''
          },
          privacyList: {
              type: Array,
              default: () => [{ text: '《蔚来汽车隐私条款》', linkTo: '/privacy' }]
          },
          textStyle: {
              type: Object,
              default: () => ({
                  textColor: '#050B27',
                  placeholderColor: '#999DAE'
              })
          },
          fields: {
              type: Array,
              default: () => []
          }
      },
      data() {
          return {
              isAgree: false,
              formRules: {
                  'formData.mobile': {
                      validate: value =>
                          validator[
                              `validateMobile${this.formData.country_code}`
                          ](value),
                      message: '请正确填写您的手机号码'
                  },
                  'formData.verification_code': {
                      require: true,
                      message: '请填写验证码'
                  },
                  isAgree: {
                      require: true,
                      callback: () => {
                          this.$refs.alerth5.onOpen();
                      }
                  },
                  'formData.fellow_mobile': {
                      // fellow号码选填
                      validate: value =>
                          !value ||
                          validator[`validateMobile${fellow_country_code}`](
                              value
                          ),
                      message: '专属顾问手机号输入错误'
                  }
              }
          };
      },
      computed: {
          isInApp() {
              return isInNioCNApp();
          },
          verificationCodeClassifier() {
              return this.isInApp ? 'login' : 'common_verification';
          },
          formData: {
              get({ form }) {
                  return form;
              },
              set(v) {
                  this.$emit('update', v);
              }
          },
          textColor() {
              return { '--text-color': this.textStyle.textColor };
          },
          placeholderColor() {
              return { '--placeholder-color': this.textStyle.placeholderColor };
          }
      },
      methods: {
          handleCountryCodeChange() {
              this.formData.mobile = '';
              this.$emit('track', 'code');
          },
          handleClearMobile() {
              this.formData.mobile = '';
          },
          handleClickVerification() {
              this.$emit('track', 'bind_phone');
              this.onVerification();
          },
          handleAgreeChange(checked) {
              if (checked) {
                  this.$emit('track', 'agree_privacy');
              }
          },
          handleInputFocus(key) {
              const targetEl = this.$refs[key];
              this.$emit('inputFocus', targetEl);
          },
          handleInputBlur() {
              this.$emit('inputBlur');
          },
          handleFellowMobileInput(event) {
              const inputValue = event.target.value;
              if (/^\d+$/.test(inputValue)) {
                  this.formData.fellow_mobile = event.target.value;
              } else {
                  event.target.value = this.formData.fellow_mobile;
              }
          },
          handleClearFellowMobile() {
              this.formData.fellow_mobile = '';
          }
      }
  };
</script>

<style lang="less">
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';

.marketing-leads-award-form {
    display: flex;
    flex-direction: column;
    padding: 0 25 * @layout375;

    .mobile {
        &-box {
            .country-code-wrap .value-box .value-text {
                color: var(--text-color);
            }
            .form-label {
                color: var(--text-color);
            }
            .value-ico {
                path {
                    fill: var(--text-color);
                }
            }
        }
        &-input {
            width: 100%;
            color: var(--text-color);
            font-size: 16 * @layout375;
            &::-webkit-input-placeholder {
                color: var(--placeholder-color);
            }
        }

    }

    .verification_code {
        &-box {
            .form-label {
                color: var(--text-color);
            }
        }
        &-input {
            flex: 1;
            width: 6em;
            color: var(--text-color);
            font-size: 16 * @layout375;

            &::-webkit-input-placeholder {
                color: var(--placeholder-color);
            }
        }
        &-button {
            width: 80 * @layout375;
            min-width: 80 * @layout375;
            height: 25 * @layout375;
            line-height: 25 * @layout375;
            border-radius: 18 * @layout375;
            text-align: center;
            font-size: 12 * @layout375;
            color: #363c54;
            margin-left: 10 * @layout375;
            background: #f0fcfc;
            color: #00bebe;
            &.disabled {
                background: #f7f7f8;
                color: #9b9da9;
            }
        }
    }

    .editable-clear-x {
        display: inline-flex;
        line-height: 44 * @layout375;
        position: absolute;
        right: 2 * @layout375;
        width: 15 * @layout375;
        path {
            fill: var(--text-color);
        }
    }

    .privacy-box {
        .privacy-ctx {
            &-t {
                color: var(--text-color);
            }
        }
        .radioimg {
            .radio_unselected {
                path {
                    fill: var(--text-color);
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/marketing/components/leads-award/award-form.vue